import React, { useState, useEffect, useRef } from "react";
import LeaseApiService from "../../services/apiService";
import { useLocation, useNavigate } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import moment from "moment";
import Select from 'react-select';
import { IoAdd } from "react-icons/io5";
import { GrDocumentUpdate } from "react-icons/gr";
import DatePicker from "react-datepicker";
import { HashLoader } from "react-spinners";
import "react-datepicker/dist/react-datepicker.css";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const ProposalView = () => {
    const apiService = new LeaseApiService();
    const [activeTab, setActiveTab] = useState(0);
    const { currencyPrecision } = useCurrency();
    const [FilterTab, setFilterTab] = useState(true);
    const [loader, setLoader] = useState(true);
    const [tentantTab, setTanantTab] = useState(false);
    const [tentantJoint, setTanantJoint] = useState(false);
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [leaseTerm, setLeaseTerm] = useState("");
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [taxCodeList, setTaxCodeList] = useState([]);
    const [additionalCharges, setAdditionalCharges] = useState([]);
    const [rentCheck, setRentCheck] = useState(false);
    const [unitRent, setUnitRent] = useState(true);
    const location = useLocation();
    const leaseData = location.state;
    const navigate = useNavigate();
    const [editIndex, setEditIndex] = useState(null);
    const [dataList, setDataList] = useState([{
        Property: [],
        Unit: [],
        noCommunity: "",
        rentPerAnum: "",
        unitClass: "",
        type: "",
        rentForPeriod: "",
        unitRefNo: "",
        bedRooms: "",
        FreeRent: "",
        discountPerc: "",
        totalArea: "",
        Landloard: "",
        taxCode: [],
        category: "",
        vat: "",
        discount: "",
        total: "",
        parkingNo: "",
        munAcNo: "",
        Parking: "",
        taxRate: "",
    }]);
    const [formData, setFormData] = useState({
        vatRecord: "",
        Property: [],
        Unit: [],
        noCommunity: "",
        rentPerAnum: "",
        unitClass: "",
        type: "",
        rentForPeriod: "",
        unitRefNo: "",
        bedRooms: "",
        FreeRent: "",
        discountPerc: "",
        totalArea: "",
        Landloard: "",
        taxCode: [],
        category: "",
        vat: "",
        discount: "",
        total: "",
        parkingNo: "",
        munAcNo: "",
        Parking: "",
        taxRate: "",
    });
    const [transData, setTransData] = useState({
        transectionDate: "",
        periodFrom: "",
        periodTo: "",
        noInstallment: "",
        CustomerName: "",
        CustomerAccount: "",
        leaseAgent: "",
        JointCustomerName: "",
        JointCustomerAccount: "",
        Broker: "",
        remarks: "",
        remarks2: "",
        arabicRemarks: "",
    });
    const totalRent = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0);
    const totalVat = dataList?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
    const rentPerAnum = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0);
    const totalDiscount = dataList?.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0);
    const calculatedTotal = dataList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
    debugger
    useEffect(() => {
        getUserList();
    }, [leaseData])

    const calculateDaysDifference = (from, to) => {
        const fromDate = new Date(from);
        const toDate = new Date(to);
        const diffTime = toDate - fromDate;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    const getUserList = async () => {
        try {
            setLoader(true)
            debugger
            const params = new URLSearchParams();
            params.append("dropdownTypes", "LPSerPropertyName,LPCustomerName,LPLeasingAgent,LPLeaseRemarks,VatPercentage");
            const customerRes = await apiService.getApiParamater("GET_DDLS_PROP", `?${params?.toString()}`);
            setTaxCodeList(customerRes?.data?.dropdowns?.VatPercentage);
            if (leaseData) {

                const leaseDataParam = new URLSearchParams();
                leaseDataParam.append("Action", "getLeaseProposalDetailsById");
                leaseDataParam.append("GroupId", leaseData?.groupId);
                const leaseDataRes = await apiService.getApiParamater("GET_COMMON_PROP", `?${leaseDataParam?.toString()}`);
                let leaseResData = ""
                if (leaseDataRes?.data?.result?.data?.length > 0) {
                    let leaseResponse = leaseDataRes?.data?.result?.data[0]
                    leaseResData = leaseResponse;
                } else {
                    let leaseResponse = leaseDataRes?.data?.result?.data
                    leaseResData = leaseResponse;
                }
                const additionalChargesParam = new URLSearchParams();
                additionalChargesParam.append("Action", "getLeaseProposalAdditionalDetailsById");
                additionalChargesParam.append("GroupId", leaseData?.groupId);
                const additionalChargesRes = await apiService.getApiParamater("GET_COMMON_PROP", `?${additionalChargesParam?.toString()}`);
                let AdditionalChargesData = additionalChargesRes?.data?.result?.data
                if (AdditionalChargesData?.length > 0) {
                    const updatedData = AdditionalChargesData.map(item => ({
                        ...item,
                        isSelected: true
                    }));
                    setAdditionalCharges(updatedData);
                } else if (AdditionalChargesData?.Description) {
                    const singleItem = {
                        ...AdditionalChargesData,
                        isSelected: true
                    };
                    setAdditionalCharges([singleItem]);
                }
                // broker = agent
                const selectedAgent = customerRes?.data?.dropdowns?.LPLeasingAgent?.find(pro => pro?.value === leaseResData?.Agent);
                // Leasing Agent = salesperson
                const SalesPerson = customerRes?.data?.dropdowns?.LPLeasingAgent?.find(pro => pro?.value === leaseResData?.SalesPerson);
                const Cust1 = customerRes?.data?.dropdowns?.LPCustomerName?.find(pro => pro?.value === leaseResData?.Cust1_No);
                const Cust2 = customerRes?.data?.dropdowns?.LPCustomerName?.find(pro => pro?.value === leaseResData?.Cust2_No);
                const remarks = customerRes?.data?.dropdowns?.LPLeaseRemarks?.find(pro => pro?.text === leaseResData?.Remarks);
                const taxCode = customerRes?.data?.dropdowns?.VatPercentage?.find(pro => parseInt(pro?.value) === leaseResData?.Tax_Code);
                // Cust no 1
                const cust1params = new URLSearchParams();
                cust1params.append('Action', 'GetCustomerDetailsByTenantNo');
                cust1params.append('TenantNo', leaseResData?.Cust1_No);
                const cust1res = await apiService.getApiParamater('GET_COMMON_PROP', `?${cust1params.toString()}`);
                // Cust no 2
                const params = new URLSearchParams();
                params.append('Action', 'GetCustomerDetailsByTenantNo');
                params.append('TenantNo', leaseResData?.Cust2_No);
                const res = await apiService.getApiParamater('GET_COMMON_PROP', `?${params.toString()}`);
                let leaseterm = calculateDaysDifference(leaseResData?.Lease_Date, leaseResData?.Lease_Expiry)
                debugger
                const transdate = moment(
                    leaseResData?.TransactionDate,
                    ["MMM DD YYYY hh:mmA", "YYYY-MM-DD HH:mm:ss"],
                    true
                );

                setTransData({
                    ...transData,
                    transectionDate: transdate.isValid() ? transdate.format("YYYY-MM-DD") : "",
                    periodFrom: leaseResData?.Lease_Date,
                    periodTo: leaseResData?.Lease_Expiry,
                    noInstallment: leaseResData?.PaymentTermNoOfChqs,
                    Broker: { label: SalesPerson?.value || "", value: SalesPerson?.text || "" },
                    leaseAgent: { label: selectedAgent?.value || "", value: selectedAgent?.text || "" },
                    CustomerName: { label: Cust1?.text || "", value: Cust1?.value || "" },
                    CustomerAccount: { label: Cust1?.value || "", value: cust1res?.data?.result?.data || "" },
                    JointCustomerName: { label: Cust2?.text || "", value: Cust2?.value || "" },
                    JointCustomerAccount: { label: Cust2?.value || "", value: res?.data?.result?.data || "" },
                    remarks: { label: remarks?.value || "", value: remarks?.text || "" },
                    remarks2: remarks?.text,
                    arabicRemarks: leaseResData?.RentPI_Remarks,
                    leaseTerm: leaseterm
                });
                setPeriodFrom(moment(leaseResData?.Lease_Date).format('YYYY-MM-DD'))
                setPeriodTo(moment(leaseResData?.Lease_Expiry).format('YYYY-MM-DD'))
                setLeaseTerm(leaseterm);
                debugger
                if (leaseDataRes?.data?.result?.data?.length > 0) {
                    const formattedEntry = leaseDataRes?.data?.result?.data?.map((item, index) => ({
                        Property: {
                            value: item.Property_Id || "", // → property_Id
                            label: item.Property_Name || "" // → propertyName
                        },
                        Unit: {
                            value: item.Unit_No || "", // → unitNo
                            label: item.Unit_No || ""
                        },
                        vatRecord: item?.Tax_Code,
                        noCommunity: "",
                        rentPerAnum: item?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
                        unitClass: item?.UnitClass,
                        type: item?.Unit_Type,
                        rentForPeriod: item?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
                        unitRefNo: item?.UnitRefNo,
                        bedRooms: item?.Bedrooms,
                        totalArea: item?.Total_Area,
                        Landloard: item?.Landlord,
                        taxCode: { label: taxCode?.text, value: taxCode?.value },
                        category: item?.Unit_Category,
                        vat: item?.VAT,
                        FreeRent: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
                        discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
                        total: item?.Total?.toFixed(currencyPrecision?.decimalNumbers),
                        parkingNo: item?.ParkingNo,
                        munAcNo: item?.MuncAcNo,
                        MunicipalityNo: item?.MunicipalityNo,
                        Parking: item?.Parking,
                        taxRate: item?.TaxPercent || 0,
                        discountPerc: item?.DiscountPercent || 0,
                        discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
                        vatRecord: item?.TaxCode,
                    }));
                    debugger
                    setDataList(formattedEntry)
                } else {
                    const formattedEntry = {
                        Property: {
                            value: leaseResData.Property_Id || "", // → property_Id
                            label: leaseResData.Property_Name || "" // → propertyName
                        },
                        Unit: {
                            value: leaseResData.Unit_No || "", // → unitNo
                            label: leaseResData.Unit_No || ""
                        },
                        vatRecord: leaseResData?.Tax_Code,
                        noCommunity: "",
                        rentPerAnum: leaseResData?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
                        unitClass: leaseResData?.UnitClass,
                        type: leaseResData?.Unit_Type,
                        rentForPeriod: leaseResData?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
                        unitRefNo: leaseResData?.UnitRefNo,
                        bedRooms: leaseResData?.Bedrooms,
                        totalArea: leaseResData?.Total_Area,
                        Landloard: leaseResData?.Landlord,
                        taxCode: { label: taxCode?.text, value: taxCode?.value },
                        category: leaseResData?.Unit_Category,
                        vat: leaseResData?.VAT,
                        FreeRent: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
                        discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
                        total: leaseResData?.Total?.toFixed(currencyPrecision?.decimalNumbers),
                        parkingNo: leaseResData?.ParkingNo,
                        munAcNo: leaseResData?.MuncAcNo,
                        MunicipalityNo: leaseResData?.MunicipalityNo,
                        Parking: leaseResData?.Parking,
                        taxRate: leaseResData?.TaxPercent || 0,
                        discountPerc: leaseResData?.DiscountPercent || 0,
                        discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
                        vatRecord: leaseResData?.TaxCode,
                    };
                    debugger
                    setDataList([formattedEntry])
                }
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error fetching data:", error?.customerRes?.data?.message);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map(
            (_, index) => index === tabIndex
        );
        setGridVisibility(newGridVisibility);
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    return (
        <div className="p-3">
            <div className="d-flex mb-3">
                <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(0)}
                    >
                        Transaction and Tenant
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(2)}
                    >
                        Additional Charges
                    </div>
                </div>
                <div className="col-lg-4 d-flex gap-1">
                    <div className="mainbtnSecondary flex-end gap-2 w-50"
                        onClick={() => navigate("/Property/Management/LeaseAgreement")}
                    >
                        <FaChevronLeft color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Transaction Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={transData?.transectionDate}
                                                disabled
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="periodFrom" className="form-label pt-1 start">Period From</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={periodFrom}
                                                disabled
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="periodTo" className="form-label pt-1 start">Period To</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={periodTo}
                                                disabled
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="leaseTerm" className="form-label pt-1 start">Lease Term</label>
                                            <input
                                                type="text"
                                                className="p-2 form-control w-75"
                                                name="leaseTerm"
                                                value={leaseTerm}
                                                readOnly
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">No. Of Installments</label>
                                            <input type="number" className="p-2 form-control w-75" name="noInstallment" min={1}
                                                value={transData?.noInstallment}
                                                readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Select Remarks</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.remarks}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks2" readOnly
                                                value={transData?.remarks2} />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Arabic Remarks</label>
                                            <input type="text" className="p-2 form-control w-75" name="arabicRemarks"
                                                readOnly
                                                value={transData?.arabicRemarks} />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantTab(!tentantTab)}>
                            <div className='h6 pt-1'>Tenant Primary Details</div>
                        </div>
                        <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.CustomerName} isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.CustomerAccount} isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.CustomerAccount?.value?.ContactNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.CustomerAccount?.value?.Email} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={transData?.CustomerAccount?.value?.IDNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.Nationality} readOnly />

                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.VATRegNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Leasing Agent</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.leaseAgent} isDisabled
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section my-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantJoint(!tentantJoint)}>
                            <div className='h6 pt-1'>Tenant Joint Details</div>
                        </div>
                        <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.JointCustomerName} isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.JointCustomerAccount} isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.JointCustomerAccount?.value?.ContactNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.JointCustomerAccount?.value?.Email} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" readOnly value={transData?.JointCustomerAccount?.value?.IDNo} />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.Nationality} readOnly />

                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.VATRegNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.Broker} isDisabled
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <>
                    <div className="cost-center-section my-3">
                        <div
                            className="d-flex cursor-pointer slide-header"
                            onClick={() => setUnitRent(!unitRent)}
                        >
                            <div className="h6 pt-1">Unit Rent Details</div>
                        </div>
                        <div className={`slide-content ${unitRent ? "open" : "closed"}`}>
                            <div
                                className={`border-box2 p-3 ${unitRent ? "slide-in" : "slide-out"
                                    }`}
                            >
                                <div className="form-group grid-contain "
                                >
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Property
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                                    color: state.isFocused ? "#000 " : "#000",
                                                    ":hover": {
                                                        backgroundColor: "#F5F5F5",
                                                        color: "#000 ",
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={formData.Property}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Unit *
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                                    color: state.isFocused ? "#000 " : "#000",
                                                    ":hover": {
                                                        backgroundColor: "#F5F5F5",
                                                        color: "#000 ",
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={formData.Unit}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Munc No.community{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="noCommunity"
                                            value={formData.noCommunity}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Rent Per Anum
                                        </label>
                                        <input
                                            type="email"
                                            className="p-2 form-control w-75"
                                            name="rentPerAnum"
                                            value={formData.rentPerAnum}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Unit Class
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="unitClass"
                                            value={formData.unitClass}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Type
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="type"
                                            value={formData.type}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Rent For period
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="rentForPeriod"
                                            value={formData.rentForPeriod}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Unit Ref No.
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="unitRefNo"
                                            value={formData.unitRefNo}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Bed Room’s
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="bedRooms"
                                            value={formData.bedRooms}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex gap-2">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Free Rent
                                        </label>
                                        <input
                                            type="number"
                                            className="p-2 form-control w-25"
                                            name="discountPerc"
                                            placeholder="%"
                                            value={formData.discountPerc}
                                            readOnly
                                        />
                                        <input
                                            type="number"
                                            className="p-2 form-control w-50"
                                            name="FreeRent"
                                            placeholder="0.00"
                                            value={formData.FreeRent}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Landlord
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="Landloard"
                                            value={formData.Landloard}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Category
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="category"
                                            value={formData.category}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Tax Code *
                                        </label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9,
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                                    color: state.isFocused ? "#000 " : "#000",
                                                    ":hover": {
                                                        backgroundColor: "#F5F5F5",
                                                        color: "#000 ",
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={formData.taxCode}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Total Area
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="totalArea"
                                            value={formData.totalArea}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex gap-4 center">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="rentCheck"
                                            style={{ width: "20px", height: "20px" }}
                                            name="rentCheck"
                                            checked={rentCheck}
                                            readOnly
                                        />
                                        <label className="text-danger">Rent-Non Leasing</label>
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            VAT
                                        </label>
                                        <input
                                            type="text"
                                            className="p-2 form-control w-75"
                                            name="vat"
                                            value={formData.vat}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Munc / Ac No.{" "}
                                        </label>
                                        <input
                                            type="number"
                                            className="p-2 form-control w-75"
                                            name="munAcNo"
                                            value={formData.munAcNo}
                                            readOnly
                                        />
                                    </div>
                                    <div className="d-flex center">
                                        <h6 className="text-danger text-bold">Unit Rent</h6>
                                    </div>
                                    <div className="d-flex">
                                        <label
                                            htmlFor="validationCustom01"
                                            className="form-label pt-1 start"
                                        >
                                            Total
                                        </label>
                                        <input
                                            type="number"
                                            className="p-2 form-control w-75"
                                            name="total"
                                            value={formData.total}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        {editIndex !== null ?
                            <div className="mainbtnSecondary flex-end gap-2" style={{ cursor: "not-allowed" }}>
                                <GrDocumentUpdate color="#fff" className="center mt-2 mx-2" />
                                <div className="center">Update</div>
                            </div> :
                            <div className="mainbtn end center gap-2" style={{ cursor: "not-allowed" }}>
                                <IoAdd color="#fff" className="center mx-2" />
                                <div className="center">Add</div>
                            </div>
                        }
                    </div>
                    <div>
                        <div
                            className="table-container my-3"
                            style={{ overflowX: "auto", height: "400px" }}
                        >
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>Action</th>
                                        <th>Property</th>
                                        <th>Unit No.</th>
                                        <th>Unit Ref No.</th>
                                        <th>Unit Class</th>
                                        <th>Area</th>
                                        <th>Discount</th>
                                        <th>Tax</th>
                                        <th>Rent</th>
                                        <th>VAT</th>
                                        <th>Total</th>
                                        <th>Rent Per Anum</th>
                                        <th>Bed Room’s</th>
                                        <th>Unit Type</th>
                                        <th>Unit Category</th>
                                        <th>Parking No</th>
                                        <th>Munc A/c No.</th>
                                        <th>Munc No. Community</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(dataList) &&
                                        dataList?.map((data, index) => (
                                            <tr key={index}>
                                                <td className='gap-3 d-flex'>
                                                    {!data.Property?.label ?
                                                        <input className="" disabled style={{ width: "80px" }} /> :
                                                        <>
                                                            <div className='pt-1' style={{ cursor: "not-allowed" }}>
                                                                <MdDelete size={25} />
                                                            </div>
                                                            <div className='pt-1' style={{ cursor: "not-allowed" }}>
                                                                <FiEdit size={25} />
                                                            </div>
                                                        </>
                                                    }
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.Property?.label || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.Unit.label || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.unitRefNo || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.unitClass || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.totalArea)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.FreeRent)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.taxCode?.label || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.rentForPeriod)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.vat)?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.total)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={Number(data.rentPerAnum)?.toFixed(currencyPrecision?.decimalNumbers)}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.bedRooms || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.type || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.category || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.parkingNo || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.munAcNo || ""}
                                                        disabled
                                                        style={{ width: "130px" }}
                                                    />
                                                </td>
                                                <td className="m-0 p-0">
                                                    <input
                                                        className="p-1"
                                                        value={data.noCommunity || ""}
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-between boxs">
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Total Units</div>
                                <div className="field">{dataList?.length || "---"}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Discount</div>
                                <div className="field">{`${totalDiscount}` || "---"}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Vat Total</div>
                                <div className="field">{totalVat || "---"}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Rent Total</div>
                                <div className="field">{totalRent || "---"}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Total Amount</div>
                                <div className="field">{calculatedTotal || "---"}</div>
                            </div>
                            <div className="d-flex gap-2">
                                <div className="totalhead center">Rent Per Anum Total</div>
                                <div className="field">{rentPerAnum || "---"}</div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {gridVisibility[2] && (
                <div
                    className="table-container my-3"
                    style={{ overflowX: "auto", height: "700px" }}
                >
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th>Select</th>
                                <th>Description</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amount</th>
                                <th>Tax Code</th>
                                <th>Vat</th>
                                <th>Total</th>
                                <th>Posting</th>
                                <th>Remarks</th>
                                <th>From Rent</th>
                            </tr>
                        </thead>
                        <tbody>
                            {additionalCharges?.map((row, index) => (
                                <tr key={row.RecordId}>
                                    {/* Select */}
                                    <td className="m-0 p-0 text-center">
                                        <div className="center mt-1">
                                            <input
                                                type="checkbox" className="center"
                                                checked={row.isSelected || false}
                                                readOnly
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    </td>

                                    {/* Description */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Description}
                                            disabled
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* Rate */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="number" onKeyDown={preventNegativeSign}
                                            value={row.Rate || ""}
                                            readOnly
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Qty */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1" onKeyDown={preventNegativeSign}
                                            type="number"
                                            value={row.Qty || ""}
                                            readOnly
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Amount */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="text"
                                            value={row.Amount >= 0 ? row?.Amount?.toFixed(currencyPrecision?.decimalNumbers) : "0.000"}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Tax Code */}
                                    <td className="m-0 p-0">
                                        <select
                                            className="p-1"
                                            value={row.TaxCode ?? ""}
                                            style={{ width: "300px" }}
                                        >
                                            <option value="">Select Tax Code</option>

                                            {taxCodeList.map((tax) => (
                                                <option key={tax.value} value={tax.value}>
                                                    {tax.text}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Vat */}
                                    < td className="m-0 p-0" >
                                        <input
                                            className="p-1"
                                            value={row.VAT?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                                            disabled
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Total */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Total?.toFixed(currencyPrecision?.decimalNumbers) || "0.00"}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Posting */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox"
                                            checked={row.Posting || false}
                                            readOnly
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>

                                    {/* Remarks */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Remarks || ""}
                                            readOnly
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* From Rent */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox" className="w-100"
                                            checked={row.IsDeposit || false}
                                            readOnly
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div >
            )}
        </div>
    );
};
export default ProposalView;
